import { utcInstantSchema } from '@baby-tracker/validation';
import { z } from 'zod';

import { successEnvelope } from './envelope.js';
import { API_BASE_PATH } from './routes.js';

export const HEALTH_PATH = `${API_BASE_PATH}/health` as const;

export const deploymentEnvironmentSchema = z.enum(['local', 'preview', 'production']);
export type DeploymentEnvironment = z.infer<typeof deploymentEnvironmentSchema>;

export const healthSchema = z.object({
    status: z.literal('ok'),
    service: z.literal('baby-tracker-api'),
    environment: deploymentEnvironmentSchema,
    /** Git SHA or release label of the deployed API; `dev` for local builds. */
    version: z.string().min(1),
    timestamp: utcInstantSchema,
});

export type Health = z.infer<typeof healthSchema>;

export const healthResponseSchema = successEnvelope(healthSchema);
export type HealthResponse = z.infer<typeof healthResponseSchema>;
